(() => {
  if (window.__sbVariantStoryLoaded) return;
  window.__sbVariantStoryLoaded = true;

  const stateSelector = '[data-sb-variant-story-section]';
  const requests = new Map();
  const contentKeys = new WeakMap();
  const parseJSON = (element, fallback) => {
    try { return JSON.parse(element?.textContent || '') || fallback; }
    catch { return fallback; }
  };
  const getKeys = (state) => {
    if (!contentKeys.has(state)) contentKeys.set(state, parseJSON(state, {}));
    return contentKeys.get(state);
  };
  const initializeStates = (scope = document) => {
    scope.querySelectorAll(stateSelector).forEach((state) => {
      state.dataset.contentKey = getKeys(state)[state.dataset.variantId] || 'default';
    });
  };
  const mainForProduct = (productId) => Array.from(document.querySelectorAll('.sb-product-main[data-product-id]'))
    .find((root) => root.dataset.productId === productId);
  const variantsForProduct = (productId) => parseJSON(
    mainForProduct(productId)?.querySelector('[data-product-variants-json]'), []
  );
  const syncSelectors = (productId, variant) => {
    const variants = variantsForProduct(productId);
    document.querySelectorAll('[data-sb-story-selector]').forEach((selector) => {
      if (selector.dataset.productId !== productId) return;
      selector.querySelectorAll('[data-sb-story-option]').forEach((group) => {
        const index = Number(group.dataset.optionPosition) - 1;
        const label = group.querySelector('[data-sb-story-selected-label]');
        if (label) label.textContent = variant.options?.[index] || '';
        group.querySelectorAll('[data-sb-story-swatch]').forEach((button) => {
          const selected = button.dataset.optionValue === variant.options?.[index];
          const available = variants.some((candidate) => candidate.available && candidate.options?.every(
            (value, position) => value === (position === index ? button.dataset.optionValue : variant.options?.[position])
          ));
          button.hidden = !available && !selected;
          button.disabled = !available;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
      });
    });
  };
  const sectionEvent = (root, name, sectionId = root.id.replace('shopify-section-', '')) => root.dispatchEvent(new CustomEvent(`shopify:section:${name}`, {
    bubbles: true,
    detail: { sectionId },
  }));
  const replaceContent = (root, nextRoot) => {
    const hero = root.querySelector('[data-product-hero]');
    const nextHero = nextRoot.querySelector('[data-product-hero]');
    const heroContent = hero?.querySelector('.sb-hero-section__content');
    const nextHeroContent = nextHero?.querySelector('.sb-hero-section__content');
    const persistentHeroMedia = '[data-hero-variant-media], [data-product-hero-shared-media]';
    if (hero?.querySelector(persistentHeroMedia) && nextHero?.querySelector(persistentHeroMedia)
      && hero.dataset.productId === nextHero.dataset.productId && heroContent && nextHeroContent) {
      const priceRow = heroContent.querySelector('[data-product-hero-price-root]');
      const nextPriceRow = nextHeroContent.querySelector('[data-product-hero-price-root]');
      const controls = heroContent.querySelector('.sb-hero-section__controls');
      const nextControls = nextHeroContent.querySelector('.sb-hero-section__controls');
      const sectionId = root.id.replace('shopify-section-', '');
      if (priceRow && nextPriceRow && controls && nextControls) {
        // Keep the price and controls connected while an artist-copy response
        // arrives. Replacing the controls mid-press can swallow a rapid click.
        sectionEvent(heroContent, 'unload', sectionId);
        heroContent.className = nextHeroContent.className;
        Array.from(heroContent.children).filter((child) => child !== priceRow && child !== controls)
          .forEach((child) => child.remove());
        priceRow.before(...Array.from(nextHeroContent.children)
          .filter((child) => child !== nextPriceRow && child !== nextControls));
        const actions = controls.querySelector('.sb-hero-section__actions');
        const nextActions = nextControls.querySelector('.sb-hero-section__actions');
        if (actions?.outerHTML !== nextActions?.outerHTML) {
          actions?.remove();
          if (nextActions) controls.append(nextActions);
        }
        root.querySelector(stateSelector).replaceWith(nextRoot.querySelector(stateSelector));
        initializeStates(root);
        sectionEvent(heroContent, 'load', sectionId);
        return;
      }
      // Persistent hero videos play independently from any copy layout.
      sectionEvent(heroContent, 'unload', sectionId);
      heroContent.replaceWith(nextHeroContent);
      root.querySelector(stateSelector).replaceWith(nextRoot.querySelector(stateSelector));
      initializeStates(root);
      sectionEvent(nextHeroContent, 'load', sectionId);
      return;
    }
    const features = Array.from(root.querySelectorAll('[data-sb-variant-feature]'));
    const nextFeatures = Array.from(nextRoot.querySelectorAll('[data-sb-variant-feature]'));
    const sameFeatures = features.length > 0 && features.length === nextFeatures.length
      && features.every((feature, index) => feature.dataset.sbVariantFeature === nextFeatures[index].dataset.sbVariantFeature);
    if (!sameFeatures) {
      sectionEvent(root, 'unload');
      root.replaceChildren(...nextRoot.childNodes);
      sectionEvent(root, 'load');
      return;
    }
    const sectionId = root.id.replace('shopify-section-', '');
    features.forEach((feature, index) => {
      const next = nextFeatures[index];
      if (feature.dataset.contentKey === next.dataset.contentKey) return;
      const media = feature.querySelector('[data-large-feature-variant-metafield]');
      const nextMedia = next.querySelector('[data-large-feature-variant-metafield]');
      const content = feature.querySelector('.sb-large-feature__content');
      const nextContent = next.querySelector('.sb-large-feature__content');
      if (media && nextMedia && content && nextContent && media.dataset.largeFeatureVariantMetafield === nextMedia.dataset.largeFeatureVariantMetafield) {
        // Variant metafield media has its own playback controller, independent of copy.
        sectionEvent(content, 'unload', sectionId);
        content.replaceWith(nextContent);
        feature.classList.toggle('sb-large-feature__layout--media-right', next.classList.contains('sb-large-feature__layout--media-right'));
        feature.dataset.contentKey = next.dataset.contentKey;
        sectionEvent(nextContent, 'load', sectionId);
        return;
      }
      sectionEvent(feature, 'unload', sectionId);
      feature.replaceWith(next);
      sectionEvent(next, 'load', sectionId);
    });
    root.querySelector(stateSelector).replaceWith(nextRoot.querySelector(stateSelector));
    initializeStates(root);
  };

  const updateContent = async (productId, variant) => {
    requests.get(productId)?.abort();
    requests.delete(productId);
    const variantId = `${variant.id}`;
    const states = Array.from(document.querySelectorAll(stateSelector)).filter((state) => state.dataset.productId === productId);
    const changed = states.filter((state) => (getKeys(state)[variantId] || 'default') !== state.dataset.contentKey);
    if (!changed.length) return;

    const controller = new AbortController();
    requests.set(productId, controller);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    url.searchParams.delete('section_id');
    url.searchParams.delete('sections');
    url.hash = '';
    try {
      const responses = [];
      for (let offset = 0; offset < changed.length; offset += 5) {
        const batch = changed.slice(offset, offset + 5);
        const sectionURL = new URL(mainForProduct(productId)?.dataset.productUrl || url.href, window.location.origin);
        sectionURL.search = url.search;
        sectionURL.searchParams.set('sections', batch.map((state) => state.dataset.sectionId).join(','));
        const response = await fetch(sectionURL, { signal: controller.signal });
        if (!response.ok) throw new Error('Section rendering failed');
        responses.push(await response.json());
      }
      if (controller.signal.aborted) return;
      const rendered = Object.assign({}, ...responses);
      const replacements = changed.map((state) => {
        const root = state.closest('.shopify-section');
        const html = rendered[state.dataset.sectionId];
        if (!root || typeof html !== 'string') throw new Error('Section missing');
        const nextDocument = new DOMParser().parseFromString(html, 'text/html');
        const nextRoot = nextDocument.getElementById(root.id);
        const nextState = nextRoot?.querySelector(stateSelector);
        const expectedKey = getKeys(state)[variantId] || 'default';
        if (!nextState || nextState.dataset.productId !== productId
          || nextState.dataset.variantId !== variantId
          || (parseJSON(nextState, {})[variantId] || 'default') !== expectedKey) {
          throw new Error('Variant section mismatch');
        }
        return { root, nextRoot };
      });

      const focused = document.activeElement;
      const focusedSelector = focused?.closest?.('[data-sb-story-selector]');
      const focusedOption = focused?.closest?.('[data-sb-story-option]');
      const focusedSection = focused?.closest?.('.shopify-section');
      replacements.forEach(({ root, nextRoot }) => {
        replaceContent(root, nextRoot);
      });
      syncSelectors(productId, variant);
      if (focusedSelector && focusedOption && focusedSection && !focused.isConnected) {
        const selector = Array.from(focusedSection.querySelectorAll('[data-sb-story-selector]'))
          .find((entry) => entry.dataset.controlId === focusedSelector.dataset.controlId);
        const group = Array.from(selector?.querySelectorAll('[data-sb-story-option]') || [])
          .find((entry) => entry.dataset.optionPosition === focusedOption.dataset.optionPosition);
        Array.from(group?.querySelectorAll('[data-sb-story-swatch]') || [])
          .find((button) => button.dataset.optionValue === focused.dataset.optionValue)?.focus({ preventScroll: true });
      }
    } catch (error) {
      if (!controller.signal.aborted) window.location.assign(url.href);
    } finally {
      if (requests.get(productId) === controller) requests.delete(productId);
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-sb-story-swatch]');
    if (!button || button.disabled || button.hidden) return;
    const selector = button.closest('[data-sb-story-selector]');
    const option = button.closest('[data-sb-story-option]');
    if (!selector || !option) return;
    if (selector.closest('[data-value-breakdown]')?.querySelector('[data-value-breakdown-add-button]')?.dataset.cartSubmitPending === 'true') return;
    const productId = selector.dataset.productId;
    const variantInput = mainForProduct(productId)?.querySelector('[data-product-variant-id]');
    const variants = variantsForProduct(productId);
    const current = variants.find((variant) => `${variant.id}` === variantInput?.value);
    const index = Number(option.dataset.optionPosition) - 1;
    if (!current || !Number.isInteger(index) || index < 0 || index >= current.options.length) return;
    const next = variants.find((variant) => variant.available && variant.options?.every(
      (value, position) => value === (position === index ? button.dataset.optionValue : current.options[position])
    ));
    if (!next || `${next.id}` === variantInput.value) return;
    variantInput.value = `${next.id}`;
    variantInput.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('variant:update', (event) => {
    const productId = `${event.detail?.data?.productId || ''}`;
    const variant = event.detail?.resource;
    if (!productId || !variant?.id) return;
    syncSelectors(productId, variant);
    updateContent(productId, variant);
  });
  document.addEventListener('shopify:section:load', (event) => initializeStates(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.sb-product-main[data-product-id]').forEach((root) => {
      requests.get(root.dataset.productId)?.abort();
      requests.delete(root.dataset.productId);
    });
  });
  initializeStates();
})();
